<div class="container container-wrapper page-container">
  <div class="page-container-content">
    <h3>{{ 'Card balance' | translate }}<span *ngIf="partner && partner.accountBalance != null">: {{
        formatMoneyText(partner.accountBalance) }}</span>
    </h3>
    <p></p>
    <h3>{{ 'Transactions' | translate }}</h3>

    <p *ngIf="!showTransactionList">{{ 'There are no card transactions' | translate }}</p>
    <app-partner-code-transaction-list *ngIf="showTransactionList" [transactions]="transactions">
    </app-partner-code-transaction-list>
  </div>
  <div *ngIf="isVUMode" class="row">
    <div class="col-12 p-0">
      <div class="container">
        <span>
          <app-backward-forward (backwardClick)="onBack()" (forwardClick)="onHomeClick()" [nextTitle]="'Home'" >
          </app-backward-forward>
        </span>
      </div>
    </div>
  </div>
</div>
